<template>
	<div class="container-fluid">
		<div v-show="errors !== null">
			<save-error
				@close="errors = null"
				:errors="errors"
			/>
		</div>
		<div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Új feladat
    		</div>
		</div>
		<div class="row d-flex justify-content-center mt-3">
			<div class="col-12 col-md-8 mt-2">
				<div class="row d-flex justify-content-center">
					<div class="col-6">
						<p>
							<label class="h5">
								Ügyfél keresés
							</label>
							<label class="small">
								Kezdd el gépelni a keresett ügyfél nevét vagy címét
							</label>
						</p>
						<input type="text" class="form-control" v-model="search">
					</div>
					<div class="col-6">
						<p class="h5">
							Kiválasztott ügyfél
						</p>
						<p class="h4">
							{{ partner }}
						</p>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-4 mt-2">
				<label class="h5">Felelős</label>
				<select v-model="task.userid" class="form-control">
				  	<option
				  		v-for="(v,k) in users"
				  		:key="k"
				  		:value="v.azon"
				  	>
				  		{{ v.nev }}
				  	</option>
				</select>
			</div>
			<div class="col-12 mt-2 mb-2" v-show="isSearch">
				<div class="table-wrapper mt-2">
					<table class="table table-hover">
				        <thead class="sticky-top bg-light">
				          	<tr>
					          	<th scope="col">#</th>
					            <th scope="col">Név</th>
					            <th scope="col">Régió</th>
					            <th scope="col">Város</th>
					            <th scope="col">Cím</th>
				          	</tr>
				        </thead>
				        <tbody>
				          	<tr
					          	v-for="(v,k) in customers"
					          	:key="`c-${k}`"
					          	:class="[v.aktiv == '1' ? 'table-success' : '']"
				          	>
					          	<td>
					          		<button
					          			class="btn btn-outline-primary"
					          			@click.prevent="setPartner(v)"
					          		>
					          			Kiválaszt
					          		</button>
					          	</td>
					            <td>{{v.nev}}</td>
					            <td>{{v.regio}}</td>
					            <td>{{v.varos}}</td>
					            <td>{{v.cim}}</td>
				          	</tr>
				        </tbody>
				    </table>
				</div>
			</div>
			<div class="col-12 col-md-4 mt-3">
				<label class="h5">
					Határidő
				</label>
				<date-picker
					class="text-center"
					v-model="task.hatarido"
					:config="date_options"
					placeholder="Határidő"
				/>
			</div>
			<div class="col-12 col-md-8 mt-3">
				<div class="row d-flex justify-content-center">
					<div class="col-12 col-md-6 mt-1">
						<label class="h5">
							Feladat rövid leírása
							<span class="small">még {{ charLeft }} karakter</span>
						</label>
						<textarea
							class="form-control"
							v-model="task.feladat_rovid"
							rows="3"
						/>
					</div>
					<div class="col-12 col-md-6 mt-1">
						<label class="h5">
							Feladat leírása
						</label>
						<textarea
							class="form-control"
							v-model="task.feladat"
							rows="5"
						/>
					</div>
				</div>
			</div>
			<div class="col-12 text-center mt-3">
				<button class="btn btn-lg btn-primary" @click.prevent="saveTask">
					Rögzítés
				</button>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import {mapGetters} from 'vuex'
export default {
	data() {
		return {
			users: [],
			task: {
				aktiv: 1
			},
			partner: '',
			customers: [],
			search: '',
			isSearch: false,
			errors: null
		}
	},

	mounted() {
		this.load()
	},

	created() {
		this.searchcustomer = _.debounce(this.checkSearch, 500)
	},

	methods: {
		load() {
			this.$Progress.start()
	      	this.isLoading = true
	      	this.req.get('/tasks/getusers')
	          	.then(res => {
	          		if(res.data.status == 'error') {
	          			this.$Progress.fail()
	              		this.isLoading = false
	              		toastr.error(res.data.text)
	              		return
	          		}
	              	this.users = res.data.users
	              	this.task.userid = this.user.azon
	              	this.$Progress.finish()
	              	this.isLoading = false
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	              	toastr.error(err)
	          	})
		},

		checkSearch(val) {
			this.$Progress.start()
			this.req.post('/customers/search/neworder2',{
				search: {
					nev: this.search,
					cim: this.search,
					cim_utca: this.search,
					varos: this.search
				}
			})
			.then(res => {
				this.customers = res.data.customers
			  	this.$Progress.finish()
			  	this.isSearch = true
			})
			.catch(err => {
				toastr.error(err)
				this.$Progress.fail()
				this.isSearch = false
			})
		},

		setPartner(item) {
			this.partner = item.nev
			this.task.uszam = item.uszam
			this.isSearch = false
		},

		saveTask() {
			this.$Progress.start()
			this.req.post('/tasks/addtask', this.task)
				.then(res => {
					if(res.data.status == 'error') {
						this.errors = res.data.errors
						toastr.error(res.data.text)
					} else {
						toastr.success(res.data.text)
						this.task = {
							aktiv: 1
						}
						this.partner = ''
					}
					this.$Progress.finish()
				})
				.catch(err => {
					console.log(err)
					toastr.error(err)
					this.$Progress.fail()
				})
		}
	},

	computed: {
		...mapGetters(['user']),

		charLeft() {
			let char = this.task.feladat_rovid !== undefined ? this.task.feladat_rovid.length : 0
			return 100 - ~~char
		}
	},

	watch: {
		search() {
      		this.searchcustomer()
    	}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/tasks/addTask.vue